export default __webpack_public_path__ + "static/media/go-logo.9bef7862.svg";